import { Dispatch } from "../../../controller";
import { Convenio } from "../../../data.types";
import { Model,StateProps } from "../../../model";

export type { Convenio } from "../../../data.types";

export interface ConvenioState extends StateProps<Convenio> {
 
}

export interface ConvenioActions extends Dispatch<Convenio> {

}

const model = new Model<Convenio,ConvenioState>("convenio");

const intialValueConvenio:Convenio = {
    ...model.getInitialValue(),
    type:"convenio",
    descricao:"",
    ativo:true,

}

export const initialValueConvenioState:ConvenioState = {
    ...model.getInititalValueState(),
    row:intialValueConvenio,
}


